import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaChevronLeft, FaChevronRight, FaCalendarAlt, FaPlus } from "react-icons/fa";

import { Link } from "react-router-dom";
import ThemeSettings from '../commun/ThemeSettings';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import Footer from '../commun/Footer';

const InventoryRateCalendar = () => {
  const [data, setData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [expandedRoom, setExpandedRoom] = useState(null);
  const [weekDates, setWeekDates] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date()); // Store the base date for the week

  useEffect(() => {
    axios.get("https://jsonplaceholder.typicode.com/posts").then(() => {
      const dummyData = [
        { roomType: "Deluxe Room", rates: [5, 5, 5, 5, 5, 5, 5] },
        { roomType: "Super Deluxe", rates: [2, 2, 2, 2, 2, 2, 2] }
      ];
      setData(dummyData);
    });

    generateWeekDates(new Date());
  }, []);

  const generateWeekDates = (baseDate) => {
    const startOfWeek = new Date(baseDate);
    startOfWeek.setDate(baseDate.getDate() - baseDate.getDay() + 1); // Monday as start of week

    const dates = [];
    let todayIndex = null;
    const today = new Date();

    for (let i = 0; i < 7; i++) {
      const date = new Date(startOfWeek);
      date.setDate(startOfWeek.getDate() + i);

      const day = date.toLocaleDateString("en-US", { weekday: "short" });
      const dayNumber = date.getDate();
      const month = date.toLocaleString("en-US", { month: "short" });

      if (date.toDateString() === today.toDateString()) {
        todayIndex = i; // Identify today's index
      }

      dates.push({ day, dayNumber, month });
    }

    setWeekDates(dates);
    setSelectedDate(todayIndex ?? 0);
  };

  const handlePrevWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() - 7);
    setCurrentDate(newDate);
    generateWeekDates(newDate);
  };

  const handleNextWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + 7);
    setCurrentDate(newDate);
    generateWeekDates(newDate);
  };

  return (


    <>
      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />

          <div className="container">
            <div className="page-inner">
              <div className="col-12">
                <div className="stats-info w-100">
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h4>Inventory & Rate</h4>
                    <div className="position-relative d-flex gap-3 flex-wrap">
                      <div className="btn-group dropdown">
                        <button className="btn btn-black btn-sm mx-3" type="button" data-bs-toggle="dropdown">Bulk Update <i className="fas fa-angle-down ms-2"></i></button>
                        <ul className="dropdown-menu" role="menu">
                          <li className="nav-item">
                            <Link className="dropdown-item" to="/Property/InventoryUpdateForm">Update Inventory & Rate</Link>
                          </li>
                        </ul>
                      </div>
                      <div>
                        <button className="btn btn-light border d-flex align-items-center">
                          <FaChevronLeft className="mx-2 text-black" onClick={handlePrevWeek} />
                          <span className="flex-grow-1 text-center">
                            <FaCalendarAlt className="mx-2 mb-1" />
                          </span>
                          <FaChevronRight className="mx-2 text-black" onClick={handleNextWeek} />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    className="calendar-header bg-white border d-flex mt-3 overflow-auto"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <div
                      className="d-flex align-items-center me-4"
                      style={{ minWidth: "150px", flexShrink: 0 }}
                    >
                      <img
                        src="assets/img/Bed.png"
                        alt="Bed"
                        style={{
                          width: "28px",
                          marginLeft: "14px",
                          marginBottom: "7px",
                          background: "none",
                        }}
                      />
                      <h6 className="m-3 fw-bold">Rooms & Rates</h6>
                    </div>

                    {weekDates.map((date, index) => (
                      <div
                        key={index}
                        className={`date-box px-3 py-2 text-center ${selectedDate === index ? "selected" : ""}`}
                        onClick={() => setSelectedDate(index)}
                        style={{ minWidth: "100px", flexShrink: 0 }}
                      >
                        {date.day} <br /> {date.dayNumber} {date.month}
                      </div>
                    ))}
                  </div>

                  <div className="room-data mt-3">
                    {data.map((room, roomIndex) => (
                      <div key={roomIndex} className="border p-3 rounded mb-2 bg-white">
                        <div className="d-flex justify-content-between align-items-center gap-4">
                          <div className="d-flex gap-3" style={{ marginRight: "5%" }}>
                            <button
                              className="rounded-1"
                              style={{ border: "none", marginBottom: "1px" }}
                              onClick={() =>
                                setExpandedRoom(expandedRoom === roomIndex ? null : roomIndex)
                              }
                            >
                              <FaPlus style={{ marginBottom: "1px", fontSize: "14px" }} />
                            </button>
                            <div className="room-name text-dark">{room.roomType}</div>
                          </div>

                          {room.rates.map((rate, rateIndex) => (
                            <div
                              key={rateIndex}
                              className={`rate-box ${rateIndex === selectedDate ? "selected" : ""}`}
                            >
                              <input type="text" value={rate} className="rate-input" readOnly />
                              <small>0 sold</small>
                            </div>
                          ))}
                        </div>

                        {expandedRoom === roomIndex && (
                          <div className="mt-2 border rounded bg-light">
                            <div className="border-black p-2 d-flex gap-5">
                              <div>
                                <h6 className="mb-1 mx-3">EP</h6>
                                <p className="fw-bold">UPDATE RATE</p>
                              </div>
                              <div className="d-flex flex-column gap-2">
                                {[{ label: "2", rate: 999 }, { label: "1", rate: 850 }].map(
                                  (item, index) => (
                                    <div
                                      key={index}
                                      className="d-flex align-items-center gap-3 border-bottom pb-2"
                                    >
                                      <span className="d-flex align-items-center gap-1 text-dark fw-semibold">
                                        <div className="border rounded shadow-sm p-2 d-flex">
                                          <span>{item.label}</span>
                                          <span> <i className="fas fa-user mx-2"></i></span>
                                        </div>
                                      </span>

                                      <div className="d-flex gap-4">
                                        {[...Array(7)].map((_, i) => (
                                          <input
                                            key={i}
                                            type="text"
                                            className="form-control text-center rounded-2 border-secondary"
                                            defaultValue={item.rate}
                                            style={{
                                              maxWidth: "120px",
                                              border: "1px solid rgb(0, 0, 0)",
                                            }}
                                          />
                                        ))}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
        <ThemeSettings />
      </div>
    </>
  );
};

export default InventoryRateCalendar;
